import React, { useState } from 'react';
import ModeSelectorNew from './ModeSelectorNew';
import ZipModePage from '../pages/ZipModePage';
import ManualModePage from '../pages/ManualModePage';

const HomeNew = ({ user, setResults, isMobile }) => {
  const [mode, setMode] = useState('zip');
  const [currentView, setCurrentView] = useState('select'); // 'select', 'zip', 'manual'

  const handleStart = () => {
    setCurrentView(mode);
  };

  const handleBack = () => {
    setCurrentView('select');
  };

  if (currentView === 'zip') {
    return <ZipModePage user={user} onBack={handleBack} />;
  }

  if (currentView === 'manual') {
    return <ManualModePage user={user} onBack={handleBack} />;
  }

  return (
    <ModeSelectorNew 
      mode={mode} 
      setMode={setMode} 
      onStart={handleStart}
    />
  );
};

export default HomeNew;
